import script from "./QuoteProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./QuoteProductDetails.vue?vue&type=style&index=0&id=34f5a370&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f5a370"]])

export default __exports__